import { FieldValues, useController, UseControllerProps } from 'react-hook-form';

import strings from 'constants/index';

import { AsyncAutocompleteProps } from '../AsyncAutocomplete/AsyncAutocomplete';
import { AsyncAutocomplete } from '../index';

type AutocompleteFormFieldProps = Omit<AsyncAutocompleteProps, 'onChange'> & {
  helperText?: string;
};

export function AutocompleteFormField<T extends FieldValues>({
  name,
  helperText,
  required,
  control,
  rules,
  defaultValue,
  ...autocompleteProps
}: UseControllerProps<T> & AutocompleteFormFieldProps) {
  const {
    field: { ref, onChange, value },
    fieldState: { error },
  } = useController<T>({
    name,
    control,
    defaultValue,
    rules: {
      required: { value: required, message: strings.field_is_required },
      ...rules,
    },
  });

  return (
    <AsyncAutocomplete
      {...autocompleteProps}
      defaultValue={value}
      required={required}
      textFieldProps={{
        ...autocompleteProps?.textFieldProps,
        'data-testid': name,
        error: !!error,
        helperText: error?.message || helperText,
        ref,
      }}
      fullWidth={true}
      onChange={onChange}
    />
  );
}
